import { DefaultRouteTabs } from '@/components/_common';
import { PageProps } from '@/types/PageProps';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { useRouteMatch } from 'react-router-dom';
import ApplicationsList from './ApplicationsList';
import ApplicationsFreeList from './ApplicationsFreeList';
import { useMatrix } from '@/core/domain/enterprise/Matrix/Matrix.hooks';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import ButtonBack from '@/components/_common/ButtonBack';
import { Divider } from 'antd';

const SearchPartApplicationPage = ({ route }: PageProps) => {
  const intl = useIntl().formatMessage;

  const { partId } = useRouteMatch<{ partId: string }>().params;

  const basePath = `/app/searchParts/${partId}`;

  const { data: matrixSettings } = useMatrix();

  return (
    <DefaultRouteTabs route={route.parent} baseKey={partId} basePath={basePath}>
      <Helmet title={intl({ id: route.name })} />

      {matrixSettings?.matrixSettings.defaultPartApplication ? (
        <ApplicationsList />
      ) : (
        <ApplicationsFreeList />
      )}

      <Divider />

      <SpaceForButton>
        <ButtonBack path="/app/searchParts" />
      </SpaceForButton>
    </DefaultRouteTabs>
  );
};

export default SearchPartApplicationPage;
